"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
var _abcjs = _interopRequireDefault(require("@bittnerdevelopmentgroup/abcjs"));
var _reactUuid = _interopRequireDefault(require("react-uuid"));
var _util = require("../util");
var _MusicUtil = require("./MusicUtil");
var _excluded = ["maxWidth", "height", "maxHeight"];
var defaultUpperRange = 15;
var defaultLowerRange = -10;
var TaskMusicViewer = exports.default = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskMusicViewer, _React$Component);
  var _super = (0, _createSuper2.default)(TaskMusicViewer);
  function TaskMusicViewer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskMusicViewer);
    _this = _super.call(this, props);
    _this.renderNotation = _this.renderNotation.bind((0, _assertThisInitialized2.default)(_this));
    _this.describeVerticalPitchClass = _this.describeVerticalPitchClass.bind((0, _assertThisInitialized2.default)(_this));
    _this.ref = /*#__PURE__*/_react.default.createRef();
    if (props.alt === undefined && !_this.props.suppressErrors) {
      throw new Error("Scores must have prop 'alt' specified.");
    }
    _this.navigation = document.getElementsByClassName("navigation");
    return _this;
  }
  (0, _createClass2.default)(TaskMusicViewer, [{
    key: "describeVerticalPitchClass",
    value: function describeVerticalPitchClass(verticalPos) {
      if (verticalPos < defaultLowerRange || verticalPos > defaultUpperRange) return '?';
      var clef = this.lastParse[0].lines[0].staff[0].clef.type;
      if (clef === "treble") return (0, _MusicUtil.describeTreblePitchPos)(verticalPos);else if (clef === "alto") return (0, _MusicUtil.describeAltoPitchPos)(verticalPos);else if (clef === "bass") return (0, _MusicUtil.describeBassPitchPos)(verticalPos);
    }
  }, {
    key: "getKeyAccidental",
    value: function getKeyAccidental(verticalPos) {
      var _iterator = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines[0].staff[0].key.accidentals),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var accidental = _step.value;
          if (accidental.verticalPos === verticalPos) {
            return accidental.acc;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var changed = [];
      for (var _i = 0, _Object$keys = Object.keys(this.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (this.props[key] !== prevprops[key]) {
          changed.push("props.".concat(key));
        }
      }
      if (changed.includes("props.scoreCredit") || changed.includes("state.alt") || changed.includes("props.staffWidth") || changed.includes("props.longAlt") || changed.includes("props.rawAbc")) {
        this.renderNotation();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderNotation();
    }
  }, {
    key: "renderNotation",
    value: function renderNotation() {
      var maxWidth = this.navigation[0] ? this.navigation[0].offsetWidth : 728;
      var render_config = {
        scale: 1,
        staffwidth: this.props.staffWidth ? maxWidth * (parseInt(this.props.staffWidth) / 100) : maxWidth,
        paddingtop: 0,
        paddingbottom: 0,
        paddingleft: 0,
        paddingright: 0,
        rangeLower: defaultLowerRange,
        rangeUpper: defaultUpperRange
      };
      this.lastParse = _abcjs.default.renderAbc(this.container, "" + this.props.rawAbc + "||", render_config);
      var svg = this.lastParse[0].engraver.renderer.paper.svg;
      for (var j = defaultUpperRange; j >= defaultLowerRange; j--) {
        var row = document.createElementNS("http://www.w3.org/2000/svg", "g");
        var pitch = this.describeVerticalPitchClass(j);
        var acc = this.getKeyAccidental(j);
        if (acc) {
          pitch += " ".concat(acc);
        }
        if (j >= 2 && j <= 10) {
          pitch += " staff";
        } else {
          pitch += " ledger";
        }
        if (j & 1) {
          // is the number odd?
          pitch += " space";
        } else {
          pitch += " line";
        }
        row.setAttribute("role", "row");
        row.setAttribute("aria-label", pitch);
        svg.appendChild(row);
        svg.setAttribute("aria-label", "sheet music");
        svg.setAttribute("pointer-events", "none");
        svg.setAttribute("alt", this.props.alt);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _ref = this.props.style || {},
        maxWidth = _ref.maxWidth,
        height = _ref.height,
        maxHeight = _ref.maxHeight,
        stylerest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
      if (this.props.longAlt || this.props.scoreCredit) {
        var id = (0, _reactUuid.default)();
        return /*#__PURE__*/_react.default.createElement("div", {
          ref: this.ref,
          className: "music-viewer",
          style: (0, _objectSpread2.default)({}, stylerest)
        }, /*#__PURE__*/_react.default.createElement("div", {
          ref: function ref(e) {
            _this2.container = e;
          },
          "aria-label": "Music Viewer",
          role: "img"
        }), (0, _util.ContentToString)(this.props.scoreCredit) && /*#__PURE__*/_react.default.createElement("span", {
          className: "photo-credit"
        }, this.props.scoreCredit), this.props.longAlt && /*#__PURE__*/_react.default.createElement("p", {
          id: "desc-".concat(id),
          className: "sr-only"
        }, this.props.longAlt));
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          ref: this.ref,
          className: "music-viewer",
          style: (0, _objectSpread2.default)({}, stylerest)
        }, /*#__PURE__*/_react.default.createElement("div", {
          ref: function ref(e) {
            _this2.container = e;
          },
          "aria-label": "Music Viewer",
          role: "img"
        }));
      }
    }
  }]);
  return TaskMusicViewer;
}(_react.default.Component);